import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, ReactiveFormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

import { ModalComponent } from '@shared/components/modals/modal/modal.component';
import { CustomOverlayRef } from '@shared/components/overlay/custom-overlay-ref';
import { DocumentLibraryService } from '@shared/services/document-library.service';
import { Document, DocumentType } from '@shared/services/gql.service';
import { Option } from '@shared/types/components.type';
import { FormGroupTyped } from '@shared/utils/utils';

import { DocumentsPageService } from '../documents-page.service';
import { DocumentsComponentForm } from '../documents.component.model';

export interface EditMultipleDocumentsModalData {
  formGroup: FormGroupTyped<DocumentsComponentForm>;
  selectedRows: Document[];
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgSelectModule, ModalComponent, ReactiveFormsModule],
  selector: 'aux-edit-multiple-documents-modal',
  templateUrl: './edit-multiple-documents-modal.html',
})
export class EditMultipleDocumentsModalComponent {
  documentLibrary = inject(DocumentLibraryService);
  documentsPageService = inject(DocumentsPageService);

  private readonly fb = inject(FormBuilder);

  documentTypeOptions: Option[] = this.documentLibrary.getDocumentOptions();
  readonly form = this.fb.group({
    documentType: null as DocumentType | null,
    site: null as null | string,
    vendor: null as null | string,
  });
  formGroup!: FormGroupTyped<DocumentsComponentForm>;
  ref = inject<
    CustomOverlayRef<
      {
        updateGrid: boolean;
      },
      EditMultipleDocumentsModalData
    >
  >(CustomOverlayRef);
  selectedRows: Document[] = [];

  constructor() {
    if (this.ref.data) {
      this.selectedRows = this.ref.data.selectedRows;
      this.formGroup = this.ref.data.formGroup;
    }
  }

  onApply() {
    const { documentType, site, vendor } = this.form.getRawValue();

    this.selectedRows.forEach((document) => {
      // todo(upgrade) find out if this is still working
      const table = this.formGroup.controls.table.getRawValue();
      const rowIndex = table.findIndex((v) => v.id === document.id);

      if (rowIndex !== -1) {
        const row = table[rowIndex];

        table.splice(rowIndex, 1, {
          ...row,
          document_type_id: documentType,
          site_id: site,
          vendor_id: vendor,
        });
        this.formGroup.controls.table.setValue(table);
      }
    });

    this.ref.close({ updateGrid: true });
  }
}
